module.exports = __webpack_public_path__ + "img/219_220_221_222.6104f74f.png";